// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1brVG","checkboxCol":"Table_checkboxCol__3ZtLa","emailCol":"Table_emailCol__1FwlH","actionCol":"Table_actionCol__yMHKl"};